__webpack_public_path__ = window.webpackDynamicPublicPath;

import React from 'react';
import { createRoot } from 'react-dom/client';

import App from '~/containers/App/App';

const appEl = document.getElementById('app');
if (appEl) {
    createRoot(appEl).render(<App />);
}
